import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  IconButton,
  Box,
  CircularProgress,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import { PlaylistV2 } from "types/graphql";

interface Props {
  id: string;
  item: PlaylistV2;
  onRemove: (id: string) => void;
  isRemoving?: boolean;
}

export function FeaturedPlaylistCard({
  id,
  item,
  onRemove,
  isRemoving,
}: Props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: "relative" as const,
    marginBottom: "8px",
    cursor: isRemoving ? "default" : "grab",
  };

  return (
    <Card ref={setNodeRef} style={style}>
      <Box display="flex" alignItems="center">
        <Box
          {...attributes}
          {...listeners}
          display="flex"
          alignItems="center"
          padding={1}
        >
          <DragIndicatorIcon />
        </Box>
        <CardMedia
          component="img"
          style={{ width: 120, height: 68, objectFit: "cover" }}
          image={item.thumbnailImageUrl || ""}
          title={item.name}
        />
        <CardContent style={{ flex: 1 }}>
          <Typography variant="h6">{item.name}</Typography>
        </CardContent>
        <Box padding={1}>
          <IconButton
            edge="end"
            color="secondary"
            aria-label="delete"
            onClick={() => onRemove(id)}
            disabled={isRemoving}
          >
            {isRemoving ? <CircularProgress size={20} /> : <DeleteIcon />}
          </IconButton>
        </Box>
      </Box>
    </Card>
  );
}
